import { render, staticRenderFns } from "./InvoicesPendingMiniCard.vue?vue&type=template&id=aaa8851a&"
import script from "./InvoicesPendingMiniCard.vue?vue&type=script&lang=js&"
export * from "./InvoicesPendingMiniCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports